import { createStyles, rem } from '@mantine/core'

export default createStyles(() => {
  return {
    root: {
      borderRadius: rem(8),
      gap: rem(2),
      background: `linear-gradient(90deg, #F5D796 0%, #F5DDA0 13.5%, #FEF8CF 21.89%, #F8D694 50.25%, #F4DB9D 69.5%, #FEF8CF 79.29%, #EEC981 93.5%)
      `,
      padding: `${rem(8)} ${rem(12)}`,
      color: '#EA0029',
    },
    heading: { color: '#EA0029' },
    description: { color: '#EA0029' },
    icon: {
      flexShrink: 0,
    },
    header: { display: 'flex', justifyContent: 'space-between' },
  }
})
